import React from 'react';
import { UserCircleIconTwoTone, PhoneTwoTone, EmailIconTwoTone } from '@room-match/shared-ui-components';
import { IProjectAttributes } from 'shared/interfaces/IProject';
import { useStyles } from '../Project.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { IContactAttachmentAttributes } from 'shared/interfaces/IContact';

type Props = {
  data: IProjectAttributes | undefined;
};

const CastingContactInformation: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  if (data === undefined) return <React.Fragment />;
  return (
    <div>
      <CustomTypography className={classes.heading}>Casting Contact Information</CustomTypography>
      {(data?.contact_attachments && data?.contact_attachments?.length > 0) ||
      data.contact_number ||
      data.contact_email ? (
        <div className={classes.flexRow}>
          {data?.contact_attachments &&
            data.contact_attachments
              .filter((v: IContactAttachmentAttributes) => v.visible_to_agents === true)
              .map((i, _) => (
                <div className={classes.contactItem} key={i.contact.id}>
                  <UserCircleIconTwoTone />
                  <CustomTypography fontSize={13} fontWeight={600}>
                    {`${i.contact?.user?.first_name} ${i.contact?.user?.last_name}`}
                  </CustomTypography>
                  <CustomTypography fontSize={13}>{`(${i.contact?.position})`}</CustomTypography>
                </div>
              ))}
          {data?.contact_number && (
            <div className={classes.contactItem} key={data?.contact_number}>
              <PhoneTwoTone />
              <CustomTypography fontSize={13} fontWeight={600}>
                {data?.contact_number}
              </CustomTypography>
              <CustomTypography fontSize={13}>(Contact Phone Number)</CustomTypography>
            </div>
          )}
          {data?.contact_email && (
            <div className={classes.contactItem} key={data?.contact_email}>
              <EmailIconTwoTone />
              <CustomTypography fontSize={13} fontWeight={600}>
                {data?.contact_email}
              </CustomTypography>
              <CustomTypography fontSize={13}>(Contact Email Address)</CustomTypography>
            </div>
          )}
        </div>
      ) : (
        <CustomTypography fontSize={14}>No Casting Contact Information Available</CustomTypography>
      )}
    </div>
  );
};

export default CastingContactInformation;
